export default __webpack_public_path__ + "images/instagram-icon_83972dbe28fffdc377a516eb92bdde55.svg";